import { Divider, Fab, MenuItem, Tooltip } from "@mui/material";
import { Add as AddIcon, ContentCopy as ContentCopyIcon, Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import Add from "./Add";
import Edit from "./Edit";
import Remove from "./Remove";
import Copy from "./Copy";

export function ActionsDialogPage({ open, close, menu, menuList, instance, reportAction, extraData = {} }) {
  return (<>
    <Add
      open={open === 1}
      close={close}
      menu={menu}
      reportAction={reportAction}
      extraData={extraData} />
    <Edit
      open={open === 2}
      close={close}
      menu={menu}
      instance={instance}
      reportAction={reportAction}
      extraData={extraData} />
    <Remove
      open={open === 3}
      close={close}
      menu={menu}
      instance={instance}
      reportAction={reportAction} />
    <Copy
      open={open === 4}
      close={close}
      menu={menu}
      menusList={menuList}
      instance={instance}
      reportAction={reportAction} />
  </>)
}

export function ActionFabButtonAdd({ t, action }) {
  return (
    <span className="fab_add">
      <Tooltip title={t("promotions_page_add_button_text")}>
        <Fab color="primary" onClick={action}> <AddIcon /></Fab>
      </Tooltip>
    </span>
  )
}

export function ActionsMenuPage({ t, action }) {
  // 2: edit, 3: delete
  return (<>
    <MenuItem onClick={() => action(2)} disableRipple>
      <EditIcon /> {t("menu_page_edit_button_text")}
    </MenuItem>
    <MenuItem onClick={() => { action(4) }} disableRipple>
      <ContentCopyIcon /> {t('button_text_duplicate')}
    </MenuItem>
    <Divider />
    <MenuItem onClick={() => action(3)} disableRipple>
      <DeleteIcon /> {t("menu_page_delete_button_text")}
    </MenuItem>
  </>)
}